import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const ArticlePage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Articles}
        fetchRecordsUrl={AdminReqUrls.admin__article__mainPage_fetch_recordList}
    />)
});
export default ArticlePage;
